<template>
  <div :style="computedBackgroundStyle" v-if="isLoginByInter !== '1'">
    <home-header />
    <!-- 个人信息模块 -->
    <personal-center :show_fee="$store.state.homeObj.show_fee" @showPayNotify="onManualPayNotify" @showPayDescAlert="onManualPayDescAlert" />
    <div v-if="imgUrl && xsbdShow == '1'" class="floating-container">
      <div v-if="show" @mouseover="mouseover" @mouseout="mouseout" class="box" :style="{ top: top + 'px', left: left + 'px' }" ref="boxRef">
        <img @click="gotoStuRegistration" id="floatImg" :src="imgUrl" />
        <span @click="close" class="closeBtn">关闭</span>
      </div>
    </div>
    <div class="pagewidth margin-top-20" style="border: 1px solid transparent; overflow: hidden">
      <div class="row">
        <!-- 通知公告模块组件 -->
        <div class="col-6" v-if="$store.state.homeObj.notice_column_show != '0'">
          <home-news />
        </div>
        <!-- 学习进度模块组件 -->
        <div class="col-6" v-if="$store.state.homeObj.progress_column_show != '0'">
          <study-rate />
        </div>
      </div>
    </div>
    <!-- 课程列表模块组件 -->
    <div class="shell-course-plan" style="margin-top: 16px">
      <course-plan :course="course" :termSet="termSet" :CurrentTime="CurrentTime" v-if="termSet.lengh != 0 && course.length != 0" />
    </div>
    <div class="margin-top-30"></div>
    <Foot />

    <!-- 信息确认弹框 -->
    <a-modal title="" :width="1000" :visible="infoCheckVisiable" :closable="false" :maskClosable="false" :footer="null">
      <InfoRecheck @refeshModalShow="refeshModalShow" />
    </a-modal>
    <!-- 修改密码弹框 -->
    <a-modal title="修改密码" :width="800" :visible="changePasswordVisiable" :closable="false" :maskClosable="false" :footer="null">
      <ForgetPassword />
    </a-modal>
    <!-- 缴费通知弹框 -->
    <PayNotifyModal
      :visible="payNotifyVisible"
      :content="payNotifyContent"
      @goPay="onPayNotifyGoPay"
      @goRegister="onPayNotifyGoRegister"
      @close="onPayNotifyClose"
    />
    <!-- 缴费弹窗 -->
    <PayModal :visible="payModalVisible" @close="payModalVisible = false" />
    <!-- 登记弹窗 -->
    <RegisterModal :visible="registerModalVisible" @close="registerModalVisible = false" />
    <!-- 站点缴费说明弹窗 -->
    <a-modal
      :width="680"
      :visible="payDescAlertVisible"
      :maskClosable="false"
      :footer="null"
      @cancel="onPayDescAlertClose"
      wrapClassName="pay-desc-alert-modal-wrap"
    >
      <div class="pay-desc-content" v-html="payDescAlertContent"></div>
    </a-modal>
  </div>
  <div :style="computedBackgroundStyle" v-else>
    <course-plan :course="course" :termSet="termSet" :CurrentTime="CurrentTime" v-if="termSet.length != 0 && course.length != 0" />
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header';
import PersonalCenter from '@/common/components/PersonalCenter';
import HomeNews from './components/News';
import StudyRate from './components/StudyRate';
import CoursePlan from './components/CoursePlan';
import Foot from '@/common/components/Foot';
import PhoneCheck from './components/PhoneCheck';
import InfoRecheck from './components/infoRecheck.vue';
import ForgetPassword from './components/ForgetPassword.vue';
import PayNotifyModal from './components/PayNotifyModal.vue';
import PayModal from './components/PayModal.vue';
import RegisterModal from './components/RegisterModal.vue';
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    StudyRate,
    HomeHeader,
    Foot,
    HomeNews,
    CoursePlan,
    PersonalCenter,
    PhoneCheck,
    InfoRecheck,
    ForgetPassword,
    PayNotifyModal,
    PayModal,
    RegisterModal,
  },
  data: function() {
    return {
      course: [],
      termSet: [],
      CurrentTime: 0,
      answer: '',
      disabled: true,
      isLoginByInter: '',
      show: true, // 是否展现飘窗
      directionX: 'right', // 飘窗的x轴方向 right left
      directionY: 'down', // 飘窗的Y轴方向 down  up
      stepX: 1, // 水平方向的步长
      stepY: 1, // 垂直方向的步长
      timer: '', // 定时器
      clientHeight: 0, // 最大的 top 值
      clientWidth: 0, // 最大的 left 值
      height: 0, // 元素的高
      width: 0, // 元素的宽
      top: 0, // 头部距离
      left: 0, // 左侧距离,
      imgUrl: '',
      xsbdShow: '',
      infoCheckVisiable: false,
      changePasswordVisiable: false,
      headerBgUrl: '',
      payNotifyVisible: false,
      payNotifyContent: '',
      payModalVisible: false,
      registerModalVisible: false,
      payDescAlertVisible: false,
      payDescAlertContent: '',
      manualPayDescAlertTriggered: false, // 是否由手动触发站点缴费说明弹窗
      notifyChecked: false, // 是否已检查缴费通知
      manualPayNotifyTriggered: false, // 是否由手动触发缴费通知（关闭后需跳转）
      notifyQueue: [], // 待顺序展示的通知队列
      unreadCount: 0, // 当前未读通知数量
    };
  },
  watch: {
    // 修改密码弹窗关闭后，检查缴费通知
    changePasswordVisiable(newVal) {
      if (!newVal && !this.infoCheckVisiable) {
        this.checkAndNotify();
      }
    },
  },
  created() {
    this.isLoginByInter = localStorage.getItem('isLoginByInter');
    if (this.$route.name !== 'myPersonalStudyFee' && localStorage.getItem('token')) {
      this.axios.get('/sys/login/userinfo').then(res => {
        let userInfo = res.result.userInfo;
        userInfo.eduLogo = res.result.eduLogo || null;
        userInfo.headTitle = res.result.headTitle;
        userInfo.pageTitle = res.result.pageTitle;
        document.title = `${userInfo.eduName} - ${userInfo.pageTitle}`;
        this.common.setStorage('userInfo', userInfo);
        this.$store.commit('SET_USERINFO', userInfo);
      });
    }
  },
  computed: {
    ...mapState(['city', 'userInfo']),

    // 计算属性生成背景样式
    computedBackgroundStyle() {
      if (localStorage.getItem('themeServer')) {
        this.headerBgUrl = '';
        const headerArr = JSON.parse(localStorage.getItem('themeServer')).filter(item => item.themeCode === 'content_bg');
        if (headerArr.length > 0) {
          if (headerArr[0].color) {
            this.headerBgUrl = headerArr[0].color;
          }
        }
      } else {
        this.axios
          .get(
            `/sys/sysClientStyleConfig/list?clientType=pc&eduCode=${
              localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).eduCode : ''
            }`
          )
          .then(res => {
            this.headerBgUrl = '';
            const headerArr = res.result.filter(item => item.themeCode === 'content_bg');
            if (headerArr.length > 0) {
              if (headerArr[0].color) {
                this.headerBgUrl = headerArr[0].color;
              }
            }
          });
      }

      // 有URL时使用图片
      if (this.headerBgUrl) {
        return {
          backgroundColor: this.headerBgUrl, // 双引号避免URL含特殊字符问题
        };
      }

      // 无URL时使用颜色
      return {
        backgroundColor: '#eaeaea', // 使用CSS变量关联Sass变量
      };
    },
  },
  mounted() {
    if (this.lastCity !== this.city) {
      this.lastCity = this.city;
      if (!localStorage.getItem('token')) {
        this.common.toURL('/login');
        return;
      }
      // 判断是否弹框提示未缴费（移至通知公告后、缴费通知前显示）

      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.getHomeInfo(); //获取首页信息

      // 检查实名认证是否完成，未完成则等待
      this.waitForRealNameAuth(() => {
        this.axios.get(`/biz/home/param`).then(res => {
          if (res.code === 200) {
            this.imgUrl = res.result.xsbd_pic;
            this.xsbdShow = res.result.xsbd_show;
            this.passwordOrInfoShow(res.result.need_change_pwd, res.result.need_archive_confirm);
            // 如果没有显示学籍确认或修改密码弹窗，则立即检查缴费通知
            this.checkAndNotify();
            // 否则 getNotify() 会在弹窗关闭后调用
            if (this.imgUrl && this.xsbdShow === '1') {
              setTimeout(() => {
                this.$nextTick(() => {
                  this.init();
                  this.onresize();
                });
              }, 100);
            }
          }
        });
      });
    }
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer);
  },
  methods: {
    // 等待实名认证完成后执行回调（必须完成，不超时）
    waitForRealNameAuth(callback) {
      if (localStorage.getItem('realNameAuthDone') === '1') {
        // 实名认证已完成，直接执行
        callback();
      } else {
        // 实名认证未完成，轮询等待直到完成
        const timer = setInterval(() => {
          if (localStorage.getItem('realNameAuthDone') === '1') {
            clearInterval(timer);
            callback();
          }
        }, 500);
      }
    },
    // 初始化飘窗规则
    init() {
      // 获取元素的高度
      this.height = this.$refs.boxRef.offsetHeight;
      // 获取元素的宽度
      this.width = this.$refs.boxRef.offsetWidth;
      // 获取可视屏幕的高度
      this.clientHeight = document.documentElement.clientHeight;
      // 获取可视屏幕的宽度
      this.clientWidth = document.documentElement.clientWidth;
      // 开始移动函数
      this.start();
    },
    refeshModalShow() {
      this.axios.get(`/biz/home/param`).then(res => {
        if (res.code === 200) {
          this.passwordOrInfoShow(res.result.need_change_pwd, res.result.need_archive_confirm);
          // 学籍确认完成后，检查缴费通知
          this.checkAndNotify();
        }
      });
    },
    // 检查并触发缴费通知（确保在学籍确认/修改密码弹窗关闭后才触发）
    checkAndNotify() {
      if (this.notifyChecked) return;
      if (!this.infoCheckVisiable && !this.changePasswordVisiable) {
        this.notifyChecked = true;
        this.getNotify();
      }
    },
    // 先修改密码 再确认信息
    passwordOrInfoShow(pwShow, infoShow) {
      this.changePasswordVisiable = pwShow == 1;
      this.infoCheckVisiable = pwShow == 0 && infoShow == 1;
    },
    // 开始设置定时器进行移动
    start() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.timer = setInterval(() => {
        this.move();
      }, 15);
    },
    // 移动函数
    move() {
      // 因为刚开始默元素位置是 0,0 在屏幕的左上角
      // 判断移动方向
      // 1 向右移动时
      if (this.directionX === 'right') {
        // 判断 移动的距离加上元素的宽度加上步长 是否大于 可视屏幕的宽度
        // 如果大于屏幕宽度就表示碰到了 右侧的边界 并进行修改方向
        if (this.left + this.width + this.stepX > this.clientWidth) {
          this.directionX = 'left';
        }
        // 2 向左移动时
      } else {
        // 只需要判断 用之前移动的左侧距离减去步长 当小于0时就表示碰到了左侧的边界
        if (this.left - this.stepX < 0) {
          this.directionX = 'right';
        }
      }
      // 3 向下移动
      if (this.directionY === 'down') {
        // 同理 需要判断当前 距离头部的距离加上元素的高度加上步长 是否大于可视屏幕的高度
        // 如果大于可视屏幕高度就表示碰到了 屏幕底部的边界
        if (this.top + this.height + this.stepY > this.clientHeight) {
          this.directionY = 'up';
        }
        // 4 向上移动
      } else {
        // 只需要判断 用之前移动的头部距离减去步长 当小于0时就表示碰到了屏幕上边的边界
        if (this.top - this.stepY < 0) {
          this.directionY = 'down';
        }
      }

      // 移动操作
      // 向右移动时将左侧的距离根据定时器的触发进行加上每次的步长
      if (this.directionX === 'right') {
        this.left += this.stepX;
        // 向左移动时就需要将之前获取到的左侧距离减去步长
      } else {
        this.left -= this.stepX;
      }
      // 向下移动时将距离头部的距离根据定时器的触发加上每次的步长
      if (this.directionY === 'down') {
        this.top += this.stepY;
        // 向上移动时需要将之前获取到的头部距离减去步长
      } else {
        this.top -= this.stepY;
      }
    },
    // 鼠标悬浮在飘窗时停止移动
    mouseover() {
      clearInterval(this.timer);
    },
    // 鼠标离开飘窗时恢复移动
    mouseout() {
      this.start();
    },
    // 关闭飘窗
    close() {
      clearInterval(this.timer);
      this.show = false;
    },
    // 窗口大小调整时重置飘窗规则
    onresize() {
      const that = this;
      window.onresize = function() {
        that.init();
      };
    },

    gotoStuRegistration() {
      this.axios.get(`/biz/home/quick/xsbd`).then(res => {
        if (res.success) {
          window.open(res.result);
        }
      });
    },

    getHomeInfo() {
      this.axios.get(`biz/subject/term/list`).then(res => {
        this.termSet = res.result;
        this.axios.get(`biz/subject/list`).then(res => {
          let data = res.result;
          let set = new Set();
          data.forEach((item, index) => {
            item.isStudyTime = this.judgeDate1(item.studyStart, item.studyEnd, res.timestamp, item.webLearnFlag);
            item.isExamTime = this.judgeDate(item.examStart, item.examEnd, res.timestamp);
            if (item.layoutTermOrder) {
              set.add(item.layoutTermOrder);
            }
          });
          this.CurrentTime = res.timestamp;
          this.course = data;
        });
      });
    },
    judgeDate(start, end, current) {
      let startDate = this.common.format(start);
      let endDate = this.common.format(end);

      if (startDate < current && endDate > current) {
        return true;
      } else {
        return false;
      }
    },

    judgeDate1(start, end, current, webLearnFlag) {
      if (webLearnFlag === 0) {
        return false;
      }
      let startDate = this.common.format(start);
      let endDate = this.common.format(end);

      if (startDate < current && endDate > current) {
        return true;
      } else {
        return false;
      }
    },
    getHomeInfoSucc: function(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.course = data.course;
      }
    },

    /**
     * 查询学生接收通知公告
     */
    getNotify() {
      const params = {
        isRead: 0,
        pageNo: 1,
        pageSize: 5,
      };
      this.axios
        .get(`/biz/user/notify/page`, { params: params })
        .then(res => {
          if (res.result.records.length > 0) {
            // 置顶（isTop=1）优先，其余按发布时间倒序，最新发布的排最前
            const getTop = n => (((n.eduNotify && n.eduNotify.isTop) || n.isTop) == 1 ? 1 : 0);
            const getTime = n => new Date((n.eduNotify && n.eduNotify.publishTime) || n.publishTime || 0).getTime();
            const sorted = res.result.records.slice().sort((a, b) => {
              if (getTop(a) !== getTop(b)) return getTop(b) - getTop(a);
              return getTime(b) - getTime(a);
            });
            // 线性展示：过滤出需要弹窗的通知（verifyMode 1/2/3），存入队列逐个弹出
            this.notifyQueue = sorted.filter(n => {
              const verifyMode = (n.eduNotify && n.eduNotify.verifyMode) || 0;
              return verifyMode != 0;
            });
            if (this.notifyQueue.length > 0) {
              this.showNextNotify();
            } else {
              this.showOtherModalsAndPayNotify();
            }
          } else {
            // 无通知时，先显示其他弹窗，最后检查缴费通知
            this.showOtherModalsAndPayNotify();
          }
        })
        .catch(() => {
          this.showOtherModalsAndPayNotify();
        });
    },

    /**
     * 线性展示通知：逐个弹出，关闭一个再开下一个
     */
    async showNextNotify() {
      if (this.notifyQueue.length === 0) {
        this.showOtherModalsAndPayNotify();
        return;
      }

      // 当前队列剩余数量即为未读通知数量
      this.unreadCount = this.notifyQueue.length;

      const notify = this.notifyQueue.shift();
      const verifyMode = notify.eduNotify.verifyMode;

      let showPromise;
      switch (verifyMode) {
        case 1:
          showPromise = this.showStayVerify(notify, true, this.unreadCount);
          break;
        case 2:
          showPromise = this.showQuestionVerify(notify, true, this.unreadCount);
          break;
        case 3:
          showPromise = this.showRedVerify(notify, true, this.unreadCount);
          break;
        default:
          // verifyMode 为 0 或其他，不弹窗，直接跳过
          break;
      }

      if (showPromise) {
        await showPromise;
      }
      // 继续展示下一个通知
      this.showNextNotify();
    },

    /**
     * 生成通知弹窗标题（含未读数量红色数字）
     */
    getNotifyTitle(count) {
      if (!count || count <= 1) {
        return '通知消息';
      }
      return (
        <span>
          通知消息
          (<span style="color: red;font-size: 15px;">
            {count}
          </span>
          <span style="margin-left: 2px;font-size: 14px;color:#666">条未读</span>
          )
        </span>
      );
    },

    /**
     * 无验证模式的弹框通知
     */
    showNoVerify(data, showMask = true) {
      return new Promise(resolve => {
        let content = (
          <div class="notify-content">
            <div class="notify-info" domPropsInnerHTML={data.eduNotify.content}></div>
          </div>
        );
        let modal = this.$info({
          title: '通知消息',
          class: 'notify-modal',
          mask: showMask,
          icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
          keyboard: false,
          content: content,
          okButtonProps: { style: { background: '#2CAF7A', border: '#2CAF7A' } },
          width: '45vw',
          onOk: () => {
            this.axios.get(`/biz/user/notify/confirm?notifyId=${data.notifyId}`).finally(() => {
              resolve(); // 关闭弹框后继续下一个
            });
          },
        });
      });
    },

    // 倒计时验证模式的弹框通知
    showStayVerify(data, showMask = true, unreadCount = 0) {
      return new Promise(resolve => {
        let duration = data.eduNotify.staySeconds;
        let info = <div style={{ overflowX: 'auto' }} class="notify-info" domPropsInnerHTML={data.eduNotify.content}></div>;

        let getContent = sec => {
          let notify = null;
          if (sec && sec > 0) {
            notify = (
              <div className="notify">
                剩余<span class="second">{sec}</span>秒后可关闭
              </div>
            );
          }
          return (
            <div>
              {info}
              {sec > 0 && <a-divider />}
              {notify}
            </div>
          );
        };

        let modal = this.$info({
          title: this.getNotifyTitle(unreadCount),
          class: 'notify-modal',
          mask: showMask,
          icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
          keyboard: false,
          content: getContent(duration),
          width: '45vw',
          okButtonProps: { props: { disabled: true } },
          onOk: () => {
            if (timer) clearInterval(timer);
            this.axios.get(`/biz/user/notify/confirm?notifyId=${data.notifyId}`).finally(() => {
              resolve();
            });
          },
        });

        if (!duration || duration <= 0) {
          modal.update({
            okButtonProps: {
              props: { disabled: false },
              style: { background: '#2CAF7A', border: '#2CAF7A' },
            },
          });
          // 无需启动定时器，直接等待用户点击确定
          return;
        }

        let timer = setInterval(() => {
          duration--;
          if (duration <= 0) {
            clearInterval(timer);
            modal.update({
              content: getContent(0),
              okButtonProps: {
                props: { disabled: false },
                style: { background: '#2CAF7A', border: '#2CAF7A' },
              },
            });
          } else {
            modal.update({
              content: getContent(duration),
            });
          }
        }, 1000);
      });
    },

    // 回答问题验证模式的弹框通知
    showQuestionVerify(data, showMask = true, unreadCount = 0) {
      return new Promise(resolve => {
        let inputChange = e => {
          if (e.target.value === data.eduNotify.answer) {
            modal.update({
              okButtonProps: {
                props: { disabled: false },
                style: { background: '#2CAF7A', border: '#2CAF7A' },
              },
            });
          } else {
            modal.update({
              okButtonProps: { props: { disabled: true } },
            });
          }
        };
        let content = (
          <div class="notify-content">
            <div class="notify-info" domPropsInnerHTML={data.eduNotify.content}></div>
            <a-divider />
            <div class="verify">
              <div class="question">{data.eduNotify.question}</div>
              <div class="answer">
                <a-input on-change={inputChange} placeholder="请输入上述问题的正确答案" />
              </div>
              <div class="question-info">(*请先回答问题再点击关闭按钮)</div>
            </div>
          </div>
        );
        let modal = this.$info({
          title: this.getNotifyTitle(unreadCount),
          class: 'notify-modal',
          mask: showMask,
          icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
          keyboard: false,
          content: content,
          width: '45vw',
          okButtonProps: { props: { disabled: true } },
          onOk: () => {
            this.axios.get(`/biz/user/notify/confirm?notifyId=${data.notifyId}`).finally(() => {
              resolve();
            });
          },
        });
      });
    },

    // 输入红字验证模式的弹框通知
    showRedVerify(data, showMask = true, unreadCount = 0) {
      return new Promise(resolve => {
        let inputChange = e => {
          if (e.target.value === data.eduNotify.answer) {
            modal.update({
              okButtonProps: {
                props: { disabled: false },
                style: { background: '#2CAF7A', border: '#2CAF7A' },
              },
            });
          } else {
            modal.update({
              okButtonProps: { props: { disabled: true } },
            });
          }
        };
        let content = (
          <div class="notify-content">
            <div class="notify-info" domPropsInnerHTML={data.eduNotify.content}></div>
            <a-divider />
            <div class="verify">
              <div class="question">请输入上述通知消息中的红字内容再点击知道了关闭通知窗口</div>
              <div class="answer">
                <a-input on-change={inputChange} placeholder="请输入上述通知消息中的红字内容" />
              </div>
            </div>
          </div>
        );
        let modal = this.$info({
          title: this.getNotifyTitle(unreadCount),
          class: 'notify-modal',
          mask: showMask,
          icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
          keyboard: false,
          content: content,
          width: '45vw',
          okButtonProps: { props: { disabled: true } },
          onOk: () => {
            this.axios.get(`/biz/user/notify/confirm?notifyId=${data.notifyId}`).finally(() => {
              resolve();
            });
          },
        });
      });
    },

    /* 如果学生没有绑定手机号码，在打开首页的时候强制先绑定手机号码 */
    creatModal() {
      let content = (
        <div class="notify-content">
          <a-divider />
          <PhoneCheck />
        </div>
      );

      this.$info({
        title: '绑定手机号',
        icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
        keyboard: false,
        content: content,
        okButtonProps: { style: { background: '#2CAF7A', border: '#2CAF7A' } },
        width: 1000,
        okText: '关闭',
        footer: 'null',
        maskClosable: false,
        onOk: () => {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (!userInfo.phone) {
            this.$message.success('您好，根据《中华人民共和国网络安全法》及相关法律规定，\n' + '请您填写正确的手机号进行认证，获取更多网络服务。', 1000);
            $this.visible(true); // 没有绑定手机点击ok按钮不能关闭弹出层
          }
        },
      });
    },

    onPayNotifyGoPay() {
      this.payNotifyVisible = false;
      this.payModalVisible = true;
    },
    onPayNotifyGoRegister() {
      this.payNotifyVisible = false;
      this.registerModalVisible = true;
    },
    onPayNotifyClose() {
      this.payNotifyVisible = false;
      // 如果是手动触发的缴费通知，关闭后重置标志（不跳转）
      if (this.manualPayNotifyTriggered) {
        this.manualPayNotifyTriggered = false;
      }
    },
    // 首页个人信息页"未缴费"点击时，手动触发缴费通知弹窗
    onManualPayNotify(content) {
      this.manualPayNotifyTriggered = true;
      this.payNotifyContent = content;
      this.payNotifyVisible = true;
    },
    // 站点缴费说明弹窗检查（自动登录流程，含token已弹校验）
    checkPayDescAlert() {
      this.axios
        .get('/biz/user/pay/payDescAlertCheck')
        .then(res => {
          if (res.code === 200 && res.result && res.result.show) {
            this.payDescAlertContent = res.result.content;
            this.payDescAlertVisible = true;
          }
        })
        .catch(() => {});
    },
    // 首页个人信息"未缴费"点击时，手动触发站点缴费说明弹窗（跳过token校验）
    onManualPayDescAlert(content) {
      this.manualPayDescAlertTriggered = true;
      this.payDescAlertContent = content;
      this.payDescAlertVisible = true;
    },
    // 关闭站点缴费说明弹窗（自动触发时记录dismiss，手动触发不记录）
    onPayDescAlertClose() {
      this.payDescAlertVisible = false;
      if (!this.manualPayDescAlertTriggered) {
        // 登录自动弹窗关闭时，记录本次已弹，刷新不再弹出
        this.axios.get('/biz/user/pay/payDescAlertDismiss').catch(() => {});
      } else {
        this.manualPayDescAlertTriggered = false;
      }
    },
    checkPayNotify() {
      this.axios
        .get('/biz/user/pay/notifyCheck')
        .then(res => {
          if (res.code === 200 && res.result && res.result.show) {
            this.payNotifyContent = res.result.content;
            this.payNotifyVisible = true;
          }
        })
        .catch(() => {});
    },
    // 其他弹窗（如未缴费提示）→ 缴费通知，统一入口
    showOtherModalsAndPayNotify() {
      this.judgeNoFeeTip(() => {
        this.checkPayNotify();
        this.checkPayDescAlert(); // 站点缴费说明弹窗
      });
    },
    // 判断是否显示未缴费弹框（支持回调，弹窗关闭后执行）
    judgeNoFeeTip(callback) {
      const that = this;
      const tipsObj = JSON.parse(localStorage.getItem('tipsObj'));
      if (tipsObj && tipsObj.isShowNoFeeTips === '1') {
        let content = (
          <div class="notify-content">
            <div class="notify-info" domPropsInnerHTML={tipsObj.noFeeTipsText}></div>
          </div>
        );
        that.$info({
          title: '系统消息',
          class: 'notify-modal',
          icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
          keyboard: false,
          content: content,
          okButtonProps: {
            style: { background: '#2CAF7A', border: '#2CAF7A' },
          },
          width: 800,
          onOk: () => {
            that.axios.get(`/biz/tips/addTipsLog?type=0`).then(res => {
              if (res.success) {
                localStorage.removeItem('tipsObj');
              }
              if (callback) callback();
            });
          },
        });
      } else {
        if (callback) callback();
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.floating-container {
  cursor: pointer;

  .box {
    position: relative;
    box-sizing: border-box;
    z-index: 2000;
    width: 300px;
    height: 200px;
    border-radius: 5px;
    position: fixed;
    text-align: left;
    color: #ffffff;
    top: 0;
    left: 0;

    img {
      max-width: 100%; /* 图片的最大宽度为父容器的100% */
      height: auto; /* 自动调整高度以保持原始比例 */
    }

    .closeBtn {
      position: absolute;
      color: #666;
      right: 0;
      bottom: -18px;
    }
  }
}

.pagewidth {
  width: 1330px;
  margin: 0 auto;
}

.notify-content {
  // padding: 20px;
}

.notify-info {
  font-size: 15px;
  margin-top: 20px;
  overflow-x: auto;
}

.verify {
  display: flex;
  align-items: center;
}

.question-info {
  font-size: 12px;
  color: #666666;
  margin-left: 10px;
  color: #f00;
}

.question {
  background: $bgColor;
  color: #fff;
  flex: 1;
  padding: 5px 20px;
  margin-right: 10px;
  border-radius: 5px;
}

.answer {
  width: 50%;
  flex: 1;
}

.ant-btn-primary {
  background: $bgColor !important;
}

.ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 10px 0;
}

.second {
  color: $bgColor;
  font-weight: bold;
}

.shell-course-plan {
  min-height: calc(100vh - 895px);
}

.ant-message-custom-content {
  max-width: 100%; /* 或者具体的最大宽度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-message-custom-content image {
  width: 1000px;
}

.pay-desc-content {
  font-size: 15px;
  margin-top: 20px;
  overflow-x: auto;
}

.pay-desc-alert-modal-wrap .ant-modal-header {
  border-bottom: 1px solid #e8e8e8;
}
</style>
<style lang="stylus">
// 通知弹框挂载在 body 上，内容由 innerHTML 注入，scoped 样式无法命中，需全局约束图片不超出弹框
.notify-info img {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}

// confirm 弹框带图标时内容区默认 margin-left 38px，去掉后内容居中展示，左右间距保持一致
.notify-modal .ant-modal-confirm-content {
  margin-left: 0 !important;
}

// 初始加载时顶部距屏幕顶部 5% 屏幕高度
// 水平居中不用 margin auto（容器出现滚动条时可用宽度变小，居中位置会偏移），
// 改用视口单位固定左边距：(100vw - 弹框宽 45vw) / 2，与滚动条是否出现无关，各弹框位置完全一致
// 注意：$info 的 class 配置挂在弹框最外层容器上（与 ant-modal-confirm 同级），必须用后代选择器命中 .ant-modal
.notify-modal .ant-modal {
  top: 5vh;
  margin: 0 0 0 calc((100vw - 45vw) / 2);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue